export const EUROPE_CONTRY_CODES = []

export const EUROPE_EQUIPMENT_LOCATION_COUNTRY_CODES = ['217', '207', 'ICE', 'ATS', '307', 'KOF', 'C128', 'LCZ', '237', 'DELTA', '353',
    'YY11', 'LKE', '269', 'ITN', 'NIO', '273', '268', '323', 'KED', 'LSK', '261', '262', '315', '271', '320',
  'ITM', '281', '306', '232', 'SFA', '334', 'BEL', '234', 'KHM', 'KSW', 'KMB', '205', '260', '308',
  '221', '263', '270', '276', 'MUG', 'KDL', '355', '225', '354', '233', '259', '220', '335'];
